import { Box, CircularProgress } from "@mui/material";
import React from "react";

export const Loading = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        my: 4,
      }}
    >
      <CircularProgress />
    </Box>
  );
};
